import {getRelatedAcceptanceObject} from 'app/acceptance/selectors';
import {useCurrentUserState} from 'app/current-user/api';

import type {GenericAcceptableDocument} from './types';
import type {StoreShapeType} from 'app/reducers/types';
import type {
  AcceptanceSerializedType,
  BaseDocumentContentType,
} from 'sweet-types';

export type AcceptanceProps = {
  acceptance: AcceptanceSerializedType | void;
};

export function getAcceptanceData<T extends GenericAcceptableDocument>(
  state: StoreShapeType,
  contentType: BaseDocumentContentType,
  object?: T
): AcceptanceProps {
  const acceptance = getRelatedAcceptanceObject(state, {
    ct: contentType,
    objectId: object?.id,
  });
  return {
    acceptance,
  };
}

export function isUserAcceptancePending<T extends GenericAcceptableDocument>(
  document?: T,
  acceptance?: AcceptanceSerializedType
): boolean {
  const currentUserId = useCurrentUserState().data!.id;
  return document != null && acceptance != null
    ? acceptance.object_id < document.current_version.id
      ? false // acceptance attached version was approved
      : acceptance.object_id === document.current_version.id &&
        document.approved_at !== null
      ? false // you are not assigned or already confirmed
      : acceptance.accept_statuses.filter(
          (s) => s.status !== true && s.user.id === currentUserId
        ).length > 0
    : false;
}
